<template>
  <div class="backColor no-print">

    <div class="links" >
      <div v-if="!hideLinkedProjects && fetchCount > 0">
        <div v-if="!canEdit" class="section-title title is-5 is-marginless">{{type}}</div>
        <div class="links-head is-flex" v-if="canEdit">
          <div v-if="linksState === 'View'" class="title is-5 is-marginless">{{type}}</div>
          <div class="title is-5 is-marginless is-hidden-touch" v-if="linksState === 'Add'">{{ $t("projectPage.add") }}  </div>
          <div class="search" v-if="linksState === 'Add'">
            <div class="control has-icons-right is-flex">
              <input class="input" type="text" :placeholder="$t('projectPage.searchProjects')" v-model.trim="searchData.query" @keyup.enter="search" />
              <div @click="search" class="icon is-small is-right"><i class="fal fa-search"></i></div>
            </div>
          </div>
          <div class="link-button" v-if="linksState === 'View'">
            <div @click="linksMode('Add')" tabindex="0" @keypress="linksMode('Add')" class="button is-small is-outlined is-rounded">
              <span><i class="fal fa-plus"></i></span>&nbsp;{{ $t("projectPage.add") }}
            </div>
          </div>

          <div class="title is-5 is-marginless is-hidden-touch" v-if="linksState === 'Edit'">{{ $t("projectPage.edit") }}</div>
          <div class="is-flex link-button" v-if="linksState === 'View'">
            <div @click="linksMode('Edit')" tabindex="0" @keypress="linksMode('Edit')" class="button is-small is-outlined is-rounded">
              <span><i class="fal fa-pencil-alt"></i></span>&nbsp;{{ $t("projectPage.edit") }}
            </div>
          </div>
          <div class="done-btn">
            <div @click="search" v-if="linksState === 'Add'" tabindex="0" class="search-btn button is-small is-rounded is-outlined is-primary">{{ $t("projectPage.search") }}</div>
            <div @click="linksMode('View')" tabindex="0" @keypress="linksMode('View')" v-if="linksState !== 'View'" class="button is-small is-outlined is-primary is-rounded">{{ $t("done") }}</div>
          </div>
        </div>

        <!-- Linked Projects -->
        <div>
          <div class="view is-flex" v-if="linksState === 'View'">
            <div class="grid-view is-flex">
              <div v-if="!projects.length" class="no-results has-text-grey-light subtitle has-text-centered">
                <span v-if="canEdit"> {{ $t("projectPage.createLinkedProjects") }} <span class="cursor-pointer has-text-primary" @click="linksMode('Add')">+{{ $t("projectPage.add") }}</span>.</span>
              </div>
              <div class="project-container" v-for="project in projects" :key="project.id">
                <contribution-card :linkedProject="project" :key="project.id" :showFollow="false" :linkStyles="true" @click="updateStateProjectID(project.id)"></contribution-card>
              </div>
            </div>
          </div>
          <div class="add is-flex" v-if="linksState === 'Add'">
            <infinite-scroll :callback="searchMore" class="is-flex grid-view">
              <div class="project-container" v-for="project in searchData.projects" :key="project.id" :class="{'is-greyed' : existingLink(project.id)}">
                <div class="add-button button is-primary" :class="{'is-cursor-disabled' : existingLink(project.id)}" @click="addLink(project)">
                  <span v-if="!existingLink(project.id)">{{ $t("projectPage.add") }}</span>
                  <span v-if="existingLink(project.id)">{{ $t("projectPage.added") }}</span>
                </div>
                <contribution-card class="project" :linkedProject="project" :key="project.id" :showFollow="false" :linkStyles="true" :disableClick="true"></contribution-card>
              </div>
              <div class="no-results has-text-grey-light subtitle has-text-centered" v-if="searchData.projects.length === 0 && searched">
                {{ $t("projectPage.noProjectsTryAnotherSearch") }}
              </div>
              <div class="pre-search has-text-grey-light subtitle has-text-centered" v-if="searchData.projects.length === 0 && !searched">
                {{ $t("projectPage.searchLinkedProjects") }}
              </div>
            </infinite-scroll>
          </div>

          <div class="edit" v-if="linksState === 'Edit'">
            <div class="project-container" v-for="project in projects" :key="project.id">
              <div @click="removeLink(project)" class="remove-button button is-danger">Remove</div>
              <contribution-card class="project" :linkedProject="project" :key="project.id" :showFollow="false" :linkStyles="true" :disableClick="true"></contribution-card>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-links has-text-grey-light subtitle has-text-centered">
        There are no linked projects at the moment.
      </div>
    </div>
  </div>
</template>

<script>
import ContributionCard from '@/components/Cards/ProjectCards/Types/Contributions'
import InfiniteScroll from '@/components/Controls/InfiniteScroll'
import socket from '@/libs/socket'
import state from '../state'
import componentState from '@/mixins/component-state'
import i18n from '@/i18n'

export default {

  components: {
    ContributionCard,
    InfiniteScroll
  },

  mixins: [componentState],

  data: function () {
    return {
      loading: false,
      subscribed: false,
      fetchCount: 0,
      tags: {},
      searchData: { query: '', limit: 6, offset: 0, projects: [], lastQuery: '', hasMore: false },
      searched: false,
      linksState: 'View',
      projectType: 'linked',
      hideLinkedProjects: false
    }
  },

  computed: {
    isStory: function () {
      return this.$route.name === 'viewStory'
    },
    projects: function () {
      return this.fetchCount > 0 ? this.$store.getters.linkedProjects(this.project.id) : []
    },
    canEdit: function () {
      return this._get(state.project.permissions.edit, false)
    },
    project: function () {
      return this.projectID ? this.$store.getters.project(this.projectID) || {} : {}
    },
    projectID: function () {
      return this._get(state.project.id)
    },
    type: function () {
      return this.$isEngCom ? 'Linked Stories' : i18n.t('projectPage.linkedProjects')
    }
  },

  mounted: function () {
    this.fetchProjects()
    if (!this.subscribed && this.project.id) {
      this.subscribed = true
      socket.subscribe('project', this.project.id, 'linked')
    }
  },

  destroyed: function () {
    if (this.subscribed) {
      this.subscribed = false
      socket.unsubscribe('project', this.project.id, 'linked')
    }
  },

  methods: {
    linked: function () {
      this.projectType = 'linked'
    },
    recommended: function () {
      this.projectType = 'recommended'
    },
    fetchProjects: function () {
      if (!this.project.id || this.loading) {
        return
      }

      this.loading = true
      this.$store.dispatch('getLinkedProjects', { project: this.project }).then((projects) => {
        this.fetchCount++
        this.hideLinkedProjects = !this.canEdit && projects.length === 0
      }).catch(() => {})
      this.loading = false
    },
    search: function () {
      if (this.searchData.query.length === 0) {
        this.searched = false
        return
      }

      if (this.searchData.query !== this.searchData.lastQuery) {
        this.searchData.projects = []
        this.searchData.offset = 0
        this.searchData.hasMore = false
      } else {
        this.searchData.offset += this.searchData.limit
      }

      this.$store.dispatch('getProjects', { limit: this.searchData.limit, offset: this.searchData.offset, query: this.searchData.query }).then((response) => {
        let matches = response.projects
        matches = matches.filter(elem => elem.id !== this.project.id)
        this.searchData.projects.push.apply(this.searchData.projects, matches)
        this.searchData.lastQuery = this.searchData.query
        this.searchData.hasMore = response.hasMore
      }).catch((messages) => {})
      this.searched = true
    },
    searchMore: function () {
      if (this.searchData.hasMore) {
        this.searchData.lastQuery = this.searchData.query
        this.search()
      }
    },
    removeLink: function (project) {
      this.$store.dispatch('removeLinkedProject', { parent: this.project, child: project }).then((response) => {
        socket.delete('project', this.project.id, 'link')
      }).catch((messages) => {})
    },
    addLink: function (project) {
      if (this.existingLink(project.id)) {
        return
      }
      this.$store.dispatch('addLinkedProject', { parent: this.project, child: project }).then((response) => {
        socket.add('project', this.project.id, 'link')
      }).catch((messages) => {})
    },
    existingLink: function (projectID) {
      const linkedList = this.$store.getters.linkedProjects(this.project.id)
      const result = linkedList.filter(elem => elem.id === projectID)
      if (result.length > 0) {
        return true
      } else {
        return false
      }
    },
    updateStateProjectID: function (projectID) {
      this._set(state.project.id, projectID)
    },
    linksMode: function (type) {
      this.linksState = type
      if (type === 'Add' || type === 'Edit') {
        this.linked()
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .backColor {
    background:#f2f2f2;
  }

  .view {
    justify-content: center;
  }

  .links {
    margin:0 auto;
    background:#fff;
    padding: 0 1rem;
    padding-bottom: 4rem;
    @include tablet-only{
      max-width:100%;
    }
    @include mobile{
      max-width: 100%;
      padding: 0;
    }
    .tabs{
      margin-top: 1rem;
      margin-bottom: 0;
      padding: 0 1rem;
      .type-tab{
        text-align: left;
        font-weight: bold;
        color: #dbdbdb;
      }
      .bold{
        color: #363636;
      }
      cursor: pointer
    }
  }

  .add{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    .input {
      border-radius: 2rem;
    }
  }
  .search {
    flex-grow: 1;
    .control {
      .input {
        border-radius: 2.5rem 0 0 2.5rem;
        font-size: 0.75rem;
        height: 2.5rem;
        width: 90%;
        padding-left: 1.25rem;
        padding-right: 0;
        position: relative;
        border-color: $primary;
        border-right: none;
        box-shadow: none;
      }

      .icon {
        color: $primary;
        margin-right: 0.5rem;
        pointer-events: auto;
        cursor: pointer;
        height: 2.5rem;
        width: 3rem;
        position: relative;
        border: 1px solid $primary;
        border-left: none;
        border-radius: 0 2.5rem 2.5rem 0;
      }
    }
  }
  .project:hover {
    border-radius: 1rem;
  }

  .project-container {
    width: 33%;
    min-width: 33%;
    display: inline-block;
    position: relative;
    z-index: 2;
    cursor: pointer;
    @include mobile {
      width: 100%;
    }
  }

  .project {
    width: 100%;
  }

  .remove-button, .add-button {
    position: absolute;
    z-index: 2;
    left: 0;
    right: 0;
    margin: auto;
    top: 30%;
    width: inherit;
    max-width: 150px;
    @include mobile {
      top: 40%;
    }
  }
  .no-results, .pre-search {
    width: 70%;
    margin: 2rem 0;
    @include mobile {
      margin: 2rem;
    }
  }
  .no-links {
    padding-top: 5rem;
    padding-bottom: 3rem;
  }
  .is-greyed {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .is-cursor-disabled {
    cursor: not-allowed;
  }
  .grid-view{
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    .project-container{
      max-width: 400px;
      @include tablet-only {
        .card-container {
          padding: 1rem;
        }
      }
    }
  }
  .links-head {
    width: 100%;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    height: 55px;
    align-items: center;
    border-bottom: 1px solid whitesmoke;
    align-items: center;
    flex-wrap: nowrap;
    padding-top: 0;
    @include mobile {
      padding: 0.5rem;
    }
    .title{
      display: inline-block;
      padding-right: 0.7rem;
    }
    .link-button {
      margin-right: 1rem;
    }
  }

  .done-btn {
    display: flex;
  }

  .search-btn {
    margin-right: 2rem;
    @include mobile {
      margin-right: 0;
    }
  }

  .section-title {
    padding: 1rem 0 0 1rem;
  }
</style>
